export const selectBannersState = (state) => state.banners;

export const selectAllBanners = (state) => state.banners.items;

export const selectIsBannersLoading = (state) => state.banners.loading.list;

export const bannersSelectors = {
    selectBannersState,
    selectAllBanners,
    selectIsBannersLoading,
};
